export default "__VITE_ASSET__Bgxs_8Hs__"